import { FC } from 'react';

import ButtonSkeleton from '../ButtonSkeleton';

interface InlineFooterSkeletonProps {
    width: string;
}

/** Shared compact loading placeholder for metrics rendered inside platform footers. */
const InlineFooterSkeleton: FC<InlineFooterSkeletonProps> = ({ width }) => (
    <span
        aria-hidden
        data-inline-footer-skeleton='true'
        style={{
            alignItems: 'center',
            display: 'inline-flex',
            height: '1rem',
            lineHeight: 0,
            verticalAlign: 'middle',
        }}
    >
        <ButtonSkeleton
            active
            size='small'
            style={{ display: 'block', height: '0.625rem', margin: 0, verticalAlign: 'middle', width }}
        />
    </span>
);

export default InlineFooterSkeleton;
